import React, { FC } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import TimeHelper from '../../../../../utils/time';
import { openExternalLink } from '../../RefundV2.helpers';

type RefundV2OrderInfoCardProps = {
    refundId: any;
    documentHeaderOfInvoice: any;
    uniquePaymentListInfo: any;
    expanded: string | false;
    otherLink: string;
    onAccordionChange: (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => void;
};

export const RefundV2OrderInfoCard: FC<RefundV2OrderInfoCardProps> = ({
    refundId,
    documentHeaderOfInvoice,
    uniquePaymentListInfo,
    expanded,
    otherLink,
    onAccordionChange,
}) => {
    const { t } = useTranslation();

    return (
        <Card style={{ height: '30rem', overflowY: 'scroll' }}>
            <CardHeader
                title={
                    <Typography noWrap gutterBottom variant="h6" component="h4">
                        <b>{t('refund.orderInfo')}</b>
                    </Typography>
                }
            />
            <Divider />
            <CardContent>
                <p>
                    <b>{t('refund.refundId')}: </b>
                    {refundId}
                </p>
                {documentHeaderOfInvoice && (
                    <p>
                        <b>{t('refund.shipmentNo')}: </b>
                        {documentHeaderOfInvoice.shippingListNo}
                    </p>
                )}

                {uniquePaymentListInfo ? (
                    uniquePaymentListInfo.map((paymentInfo: any, index: number) => (
                        <Accordion
                            key={index}
                            id={'shipment-' + paymentInfo.paymentId}
                            expanded={expanded === 'panel' + index}
                            onChange={onAccordionChange('panel' + index)}
                            style={{
                                height: 'auto',
                                border: '1px gray solid',
                                marginBottom: '0.5rem',
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={'panel' + index + 'bh-content'}
                                id={'panel' + index + 'bh-header'}
                            >
                                <p>
                                    <b>{t('refund.orderNo')}: </b>
                                    <label
                                        className="linktxt"
                                        onClick={() => {
                                            openExternalLink(
                                                `${otherLink}/orderdetail?OrderNumber=${paymentInfo.orderNumber}`,
                                                '_blank'
                                            );
                                        }}
                                    >
                                        {paymentInfo.orderNumber}
                                    </label>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p>
                                    <b>{t('refund.date')}: </b>
                                    {TimeHelper.formatDateHour(paymentInfo.createDate)}
                                </p>
                            </AccordionDetails>
                        </Accordion>
                    ))
                ) : (
                    <div />
                )}
            </CardContent>
        </Card>
    );
};
